import {
  reportTemplatesApi,
  listAllPages,
} from "@/api/clients/reportGeneratorSdk";

export const ReportTemplateClient = {
  list: async (filters = {}) =>
    listAllPages((page) =>
      reportTemplatesApi.list({
        serviceId: filters.service_id,
        page,
        pageSize: 100,
      })
    ),
};
